import { useForm } from "react-hook-form";
import { useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import MainContainer from "../../components/container/MainContainer";
import {
  getOrgProjectReports,
  unsetOrganizations,
} from "../../features/organizationsSlice";
import {
  getProjectStatuses,
  unsetProjectStatuses,
} from "../../features/projectStatusesSlice";
import { Link, useLocation } from "react-router-dom";
import SelectField from "../../components/form/SelectField";
import InputField from "../../components/form/InputField";
import Loading from "../../components/loading/Loading";
import { capitalizeFirst, sumArray } from "../../util";
import SecondContainer from "../../components/container/SecondContainer";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const ProjectReport = () => {
  const dispatch = useDispatch();
  const { location } = useLocation();
  const organizations = useSelector((state) => state.organizations.data);
  const statuses = useSelector((state) => state.projectStatuses.data);
  const statusesLoad = useSelector(
    (state) => state.projectStatuses.load.getProjectStatuses
  );
  const reportLoad = useSelector(
    (state) => state.organizations.load.getOrgProjectReports
  );
  const { register, handleSubmit } = useForm({
    defaultValues: {
      start_date: `${new Date().getFullYear()}-01-01`,
      end_date: new Date().toISOString().split("T")[0],
      work: 100,
    },
  });

  useEffect(() => {
    dispatch(getOrgProjectReports());
    dispatch(getProjectStatuses());
    return () => {
      dispatch(unsetProjectStatuses());
      dispatch(unsetOrganizations());
    };
  }, []);

  const countries = organizations.map((item) => {
    return {
      id: item.country_id,
      name: item.country,
    };
  });

  const onSubmit = async (data) => {
    try {
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  if (reportLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (reportLoad === loadStatus.loading) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <SecondContainer className="text-text-1 bg-content">
      <h3 className="mb-5">Project Report</h3>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="filters mb-3 flex items-baseline justify-start gap-2"
      >
        <div>
          <SelectField
            register={register}
            name="country"
            data={[{ id: "", name: "-- Select Country" }, ...countries]}
          />
        </div>
        <div>
          <SelectField
            register={register}
            name="status"
            data={[{ id: "", name: "-- Select Status" }, ...statuses]}
          />
        </div>

        <div>
          <InputField register={register} name="start_date" type="date" />
        </div>
        <div>
          <InputField register={register} name="end_date" type="date" />
        </div>

        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Apply Filters
        </button>
      </form>
      <div className="table-container">
        {organizations && (
          <table className="w-full bg-bkg2 ">
            <thead>
              <tr className="whitespace-nowrap">
                <th className="w-1/12 p-1 px-3 bg-bkg2 rounded-l-md">No.</th>
                <th className="w-3/12 p-1 px-3 bg-bkg2 ">Project Title</th>
                <th className="w-1/12 p-1 px-3 bg-bkg2">Description</th>
                <th className="w-1/12 p-1 px-3 bg-bkg2">Location</th>
                <th className="w-1/12 p-1 px-3 bg-bkg2">Contact Person</th>
                <th className="w-1/12 p-1 px-3 bg-bkg2">Proj Budget</th>
                <th className="w-3/12 p-1 px-3 bg-bkg2 ">Donor</th>
                <th className="w-1/12 p-1 px-3 bg-bkg2 text-center">Status</th>
                <th className="w-2/12 p-1 px-3 bg-bkg2">Remarks</th>
                <th className="w-1/12 p-1 px-3 bg-bkg2">Start Date</th>
                <th className="w-1/12 p-1 px-3 bg-bkg2">End Date</th>
              </tr>
            </thead>
            <tbody>
              {organizations.map((items, index) => {
                return (
                  items.projects.length > 0 && (
                    <Fragment key={index}>
                      <tr className="">
                        <td colSpan="13" className="mt-3 ">
                          <div className="flex justify-start items-center  mt-6 bg-primary/55 py-2 px-1 gap-3 rounded-md">
                            <span className="py-1 px-3 text-text-gen font-semibold text-lg">
                              <span> {items.country}</span>
                            </span>
                          </div>
                        </td>
                      </tr>
                      {items.projects.map((project, index) => (
                        <tr key={project.id}>
                          <td className="border px-4 py-2">{index + 1}</td>
                          <td className="border px-4 py-2">
                            <Link to={"/project-reports/" + project.id}>
                              {project.name}
                            </Link>
                          </td>
                          <td className="border px-4 py-2">
                            {project.description}
                          </td>
                          <td className="border px-4 py-2">
                            {project.community.name}
                          </td>
                          <td className="border px-4 py-2">
                            {project.Creator
                              ? `${
                                  project.Creator.first_name
                                } ${project.Creator.last_name.toUpperCase()}  ${
                                  project.Creator.phone
                                    ? project.Creator.phone
                                    : ""
                                }`
                              : "-"}
                          </td>
                          <td className="border px-4 py-2">{`${
                            project.currency ? project.currency : "N/A"
                          } ${sumArray(project.total_cost)}`}</td>
                          <td className="border px-4 py-2 w-24">
                            {(project.donor_projects.length > 0 &&
                              project.donor_projects.map((i, ind) => (
                                <p key={ind}>{i.donor.name}</p>
                              ))) || <p>N/A</p>}
                          </td>
                          <td className="border px-4 py-2 text-center">
                            <span
                              className="py-1.5 px-4 text-white rounded-md"
                              style={{
                                backgroundColor: project.project_status.color,
                              }}
                            >
                              {capitalizeFirst(project.project_status.name)}
                            </span>
                          </td>
                          <td className="border px-4 py-2">
                            {project.provincial_remarks
                              ? project.provincial_remarks
                              : " N/A "}
                          </td>
                          <td className="border px-4 py-2">
                            {project.planned_start_date
                              ? new Date(
                                  project.planned_start_date
                                ).toDateString()
                              : "Not Started"}
                          </td>
                          <td className="border px-4 py-2">
                            {project.actual_end_date
                              ? project.end_date
                              : " N/A "}
                          </td>
                        </tr>
                      ))}
                    </Fragment>
                  )
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </SecondContainer>
  );
};

export default ProjectReport;
